import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function scrollPageToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
  if (document.body) {
    document.body.scrollTop = 0;
  }
}

/**
 * Resets window scroll when the route pathname changes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollPageToTop();
  }, [pathname]);

  return null;
}
